import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Upload, Form, Button, Input, Typography } from 'antd'

const { Text, Title } = Typography

class InputUpload extends Component {
	state = {
		file: undefined,
		phone: false,
	}

    handleAdd = async images => {
		// if(images){
		// 	const isLt2M = images.size / 1024 / 1024 < 1;
		// 	if (!isLt2M) {
		// 		this.props.onAdd(null)
		// 		message.error('ไฟล์ขนาดใหญ่เกิน 1MB กรุณาเลือกไฟล์ใหม่อีกครั้ง');
		// 	}else{
		// 		this.props.onAdd(images)
		// 	}
		// }
	}

	onChange = async (e) => {
		let phonenumber = e.target.value
		let re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[,-\s\./0-9]*$/;
		if(re.test(e.target.value)){
			// await this.setState({phone:true})
			// await this.props.onChangePhone(phonenumber)
		}
		else if (!e.target.value) {
			// this.props.onChangePhone(false)
		}
		else{	
			// await this.setState({phone:false})
			// this.props.onChangePhone(null)
		}
	}

	onChangeText = async (e) =>{
		const { onChangeValueManageuser, name } = this.props
		onChangeValueManageuser(e.target.value, name)
	}

	// componentDidMount() {
	// 	let re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[,-\s\./0-9]*$/;
	// 	console.log("re.test('a')",re.test('11-,1a'));
	// }

	render() {
		const { values, required, name, label, mode, placeholder, onChangeInput = '', comment = "" } = this.props
		const { getFieldDecorator } = this.props.form;

		return (
			<>
				<Form.Item label={label} className="mb-0">
                        <input
                            id="input-file"
                            name={name}
                            type="file"
                            // accept="file_extension"
                            rules={required ? [{ required: true, message: 'กรุณาอัปโหลดไฟล์ PDF' }] : ''}
                            onChange={e => this.handleAdd(e.target.files[0])}
                        />
				</Form.Item>
			</>
		)
	}
}

InputUpload.defaultProps = {
	autoFocus: false
}

InputUpload.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedInputUpload = Form.create()(InputUpload)

export default withApollo(WrappedInputUpload)